import { Box, Button } from '@material-ui/core';
import React, { FC } from 'react';

export interface Props {
    search: (event: React.ChangeEvent<HTMLInputElement>) => void;
    applySearch: () => void;
    searchString: string;
    clearSearch: () => void
}

const TablesSearch: FC<Props> = ({search,searchString, applySearch, clearSearch}) => {
    return (
        <div className="filter-dropdown">
            <input placeholder="search"  value={searchString} onChange={search} />

            <hr />
            <div className="filter-button-container">
                <Box display="flex" justifyContent="space-evenly" alignItems="center" paddingTop="1em">
                    <Button id="apply-button" onClick={applySearch}>Filter</Button>
                    <Button id="clear-button" onClick={clearSearch}>Clear</Button>
                </Box>
            </div>
        </div >
    )
}

export default TablesSearch